import service from '@/services'

const state = {

}

const getters = {}

const actions = {
  getProList: ({commit}, payload) => {
    return service.getProList(commit, payload)
  },
  updatePro: ({commit}, payload) => {
    return service.updatePro(commit, payload)
  },
  updateBrowse: ({commit}, payload) => {
    return service.updateBrowse(commit, payload)
  },
  addorupdate: ({commit}, payload) => {
    return service.addorupdate(commit, payload)
  },
  partnerQuery: ({commit}, payload) => {
    return service.partnerQuery(commit, payload)
  },
  deletePro: ({commit}, payload) => {
    return service.deletePro(commit, payload)
  },
  getAtlas: ({commit}, payload) => {
    return service.getAtlas(commit, payload)
  },
  deleteAltas: ({commit}, payload) => {
    return service.deleteAltas(commit, payload)
  },
  imagestemps: ({commit}, payload) => {
    return service.imagestemps(commit, payload)
  },
  addAltas: ({commit}, payload) => {
    return service.addAltas(commit, payload)
  },
  addimagestemps: ({commit}, payload) => {
    return service.addimagestemps(commit, payload)
  },
  imagestempsQuery: ({commit}, payload) => {
    return service.imagestempsQuery(commit, payload)
  },
  partnerAdd: ({commit}, payload) => {
    return service.partnerAdd(commit, payload)
  }
}

const mutations = {

}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/company.js